export default __webpack_public_path__ + "static/media/icon-chevron-up.afb1a204.svg";